// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { hashMultiBallot, hashBallot512, decodeAuditableBallot, decodeAuditableMultiBallot, getLayoutProperties, getPoints, generateSampleAuditableBallot, checkIsBlank, verifyBallotSignature, verifyMultiBallotSignature, verifyAuditableBallotCiphertext, verifyAuditableMultiBallotCiphertext, isPreferential, } from "@sequentech/ui-core";
export var provideBallotService = function () { return ({
    hashMultiBallot: hashMultiBallot,
    hashBallot512: hashBallot512,
    decodeAuditableBallot: decodeAuditableBallot,
    decodeAuditableMultiBallot: decodeAuditableMultiBallot,
    getLayoutProperties: getLayoutProperties,
    getPoints: getPoints,
    generateSampleAuditableBallot: generateSampleAuditableBallot,
    checkIsBlank: checkIsBlank,
    verifyBallotSignature: verifyBallotSignature,
    verifyMultiBallotSignature: verifyMultiBallotSignature,
    verifyAuditableBallotCiphertext: verifyAuditableBallotCiphertext,
    verifyAuditableMultiBallotCiphertext: verifyAuditableMultiBallotCiphertext,
    isPreferential: isPreferential,
}); };
